// extracted by mini-css-extract-plugin
export default {"storeItem":"index_storeItem__1He0p"};